export const fileProcessingStatusEnum = {
  QUEUED: 'QUEUED',
  PROCESSED: 'PROCESSED',
  PROCESSED_WITH_ERRORS: 'PROCESSED_WITH_ERRORS',
  QUARANTINED: 'QUARANTINED',
  UNKNOWN: 'UNKNOWN',
} as const

export type FileProcessingStatusEnum = (typeof fileProcessingStatusEnum)[keyof typeof fileProcessingStatusEnum]

export type FileProcessingStatus = FileProcessingStatusEnum